import type { RouteRecordRaw } from 'vue-router';

import { useAuth } from '@/composable/msal';
import { RouteNames } from '@/router/constants/routeName';

const auth = useAuth();

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login/oauth2/code',
    name: RouteNames.Login,
    redirect: {
      name: RouteNames.Machines,
    },
  },
  {
    path: '/logout',
    name: RouteNames.Logout,
    component: {
      template: RouteNames.Logout,
    },
    meta: {
      public: true,
    },
    beforeEnter: async () => {
      localStorage.clear();
      await auth.logoutRedirect();
    },
  },
];

export default authRoutes;
